import { RecaptchaVersionConfig } from '.';

export interface RecaptchaConfig {
    recaptchav2?: RecaptchaVersionConfig;
    recaptchav3?: RecaptchaVersionConfig;
    recaptchaBaseUrl?: string;
    recaptchaRefreshInterval?: number;
}
